export const lpad = (input: number|string, length: number, padding: string) =>
    (padding.repeat(length) + input).slice(-length);

export const capitalizeFirstLetter = (input: string) =>
    input.charAt(0).toUpperCase() + input.slice(1);
